import { RouterModule, Routes } from '@angular/router';
import { privateGuard } from './guards/private.guard';

const APP_ROUTES: Routes = [
  // CALLBACK ROUTES
  { path: 'verify-email',
    loadComponent: () => import('./shared/pages/verify-email/verify-email.component').then(c => c.VerifyEmailComponent),
  },
  // BIND TRANSACTION (accessible to both authenticated and unauthenticated users)
  { path: 'bind',
    loadComponent: () => import('./shared/pages/bind-transaction/bind-transaction.component').then(c => c.BindTransactionComponent),
  },
  // PRIVATE ROUTES
  { path: '',
  loadChildren: () => import('./private/private.module').then(m => m.PrivateModule),
  canMatch: [privateGuard],
  },
  // PUBLIC ROUTES
  { path: '',
  loadChildren: () => import('./public/public.module').then(m => m.PublicModule),
  },
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES);
